<template>
  <PostBody/>
</template>

<script>
// @ is an alias to /src
import PostBody from '@/components/PostBody.vue'

export default {
  name: 'PostView',
  components: {
    PostBody
  }
}
</script>
